import {Component, OnInit} from '@angular/core';
import {DictamenService} from "../../../service/dictamen.service";
import {Dictamen} from "../../../domain/dictamen";
import {Router} from "@angular/router";
import {GlobalAppService} from "../../../../core/commons/global-app.service";
import {ConfirmationService} from "primeng/components/common/api";
import {MessageSeverity} from "app/core/commons/message-severity";

@Component({
    selector: 'app-dictamenes-list',
    templateUrl: './dictamenes-list.component.html',
    styleUrls: ['./dictamenes-list.component.scss'],
    providers: [DictamenService]
})
export class DictamenesListComponent implements OnInit {

    dictamenes: Dictamen[] = [];

    constructor(private dictamenService: DictamenService,
                private confirmationService: ConfirmationService,
                private router: Router,
                private appService: GlobalAppService) {
    }

    ngOnInit() {
        this.dictamenService.getAll().subscribe(
            dictamenes => this.dictamenes = dictamenes
        );
    }

    public addDictamen() {
        this.router.navigate(['home', 'dictamenes', "new"])
    }

    public editDictamen(d: Dictamen) {
        this.router.navigate(['home', 'dictamenes', d.id])
    }

    public downloadDictamen(d: Dictamen) {
        this.dictamenService.downloadPDF(d.id.toString())
            .subscribe(res => {
                var fileURL = URL.createObjectURL(res);
                var downloadLink = document.createElement("a");
                downloadLink.href = fileURL;
                downloadLink.download = d.getFileName();
                downloadLink.click();
            });
    }

    public deleteDictamen(d: Dictamen) {
        this.confirmationService.confirm({
            message: '¿Está seguro que desea eliminar el dictamen?',
            icon: 'fa ui-icon-delete-forever',
            accept: () => {
                this.dictamenService.delete(d)
                    .switchMap(res => this.dictamenService.getAll())
                    .subscribe(
                        dictamenes => {
                            this.dictamenes = dictamenes;
                            this.appService.sendMsg(MessageSeverity.SUCCESS, "Eliminado", "Se ha eliminado el dictamen.")
                        },
                        error => {
                            this.appService.sendMsg(MessageSeverity.ERROR, "Error", "No ha sido posible eliminar el dictamen.")
                        });
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/dictamenes/dictamenes-list/dictamenes-list.component.ts